export default __webpack_public_path__ + "static/media/simpeg-1.84580d61.png";